(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["k-blog"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('k-journal-browser'))customElements.define('k-journal-browser',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.cards=[...this.querySelectorAll('[data-journal-categories]')];this.cards.sort((a,b)=>Number(b.dataset.journalDate)-Number(a.dataset.journalDate));const grid=this.querySelector('[data-journal-grid]');this.cards.forEach(card=>grid.append(card));this.filter=(category,change=false)=>{const links=[...this.querySelectorAll('[data-journal-category]')];if(!links.some(link=>link.dataset.journalCategory===category))category=this.dataset.default;let count=0;this.cards.forEach(card=>{card.hidden=category!=='all'&&!card.dataset.journalCategories.split(',').includes(category);if(!card.hidden)count++;});links.forEach(link=>{if(link.dataset.journalCategory===category)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});this.querySelector('[data-journal-count]').textContent=this.dataset.countLabel.replace('__count__',count);this.querySelector('[data-journal-empty]').hidden=count>0;if(change){const url=new URL(location.href);url.hash='journal-'+category;history.pushState({},'',url);}};this.addEventListener('click',event=>{const link=event.target.closest('[data-journal-category]');if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();this.filter(link.dataset.journalCategory,true);},{signal});window.addEventListener('popstate',()=>this.filter(location.hash.replace('#journal-','')),{signal});this.filter(location.hash.replace('#journal-',''));}
 disconnectedCallback(){this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-faq-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('k-faq-guide'))customElements.define('k-faq-guide',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.questions=[...this.querySelectorAll('[data-faq-question]')];this.search=this.querySelector('[data-faq-search]');this.button=this.querySelector('[data-faq-expand]');this.status=this.querySelector('[data-faq-status]');this.querySelector('.kfaq__tools').hidden=false;this.search.addEventListener('input',()=>this.filter(),options);this.button.addEventListener('click',()=>{const visible=this.questions.filter(q=>!q.hidden);const open=!visible.every(q=>q.open);visible.forEach(q=>q.open=open);this.button.textContent=open?this.dataset.collapseLabel:this.dataset.expandLabel;},options);this.querySelectorAll('.kfaq__nav a[href^="#"]').forEach(link=>link.addEventListener('click',()=>{this.search.value='';this.filter();},options));this.openHash=()=>{const id=decodeURIComponent(location.hash.slice(1));const target=document.getElementById(id);if(target&&this.contains(target)&&target.matches('details'))target.open=true;};window.addEventListener('hashchange',this.openHash,options);this.openHash();}
 filter(){const query=this.search.value.trim().toLocaleLowerCase();let count=0;this.questions.forEach(question=>{const matches=!query||question.textContent.toLocaleLowerCase().includes(query);question.hidden=!matches;if(matches)count++;question.open=Boolean(query)&&matches;});this.querySelectorAll('[data-faq-topic]').forEach(topic=>topic.hidden=![...topic.querySelectorAll('[data-faq-question]')].some(q=>!q.hidden));this.querySelector('[data-faq-empty]').hidden=count!==0;this.status.textContent=query?this.dataset.countText.replace('__count__',count):'';this.button.textContent=query?this.dataset.collapseLabel:this.dataset.expandLabel;}
 disconnectedCallback(){this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-fiber-blend"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('k-fibre-card'))customElements.define('k-fibre-card',class extends HTMLElement{connectedCallback(){if(this.abort)return;this.abort=new AbortController();const opts={signal:this.abort.signal};this.button=this.querySelector('button');this.front=this.querySelector('[data-front]');this.back=this.querySelector('[data-back]');this.name=this.front.querySelector('h3').textContent;this.button.hidden=false;this.setAttribute('data-ready','');this.flip(false);this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(hover:hover) and (pointer:fine)').matches)this.flip(true);},opts);this.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')this.flip(false);},opts);this.button.addEventListener('click',e=>{this.flip(!this.hasAttribute('data-flipped'));},opts);this.button.addEventListener('keydown',e=>{if(e.key==='Escape')this.flip(false);},opts);}flip(open){this.toggleAttribute('data-flipped',open);this.button.setAttribute('aria-expanded',String(open));this.front.setAttribute('aria-hidden',String(open));this.back.setAttribute('aria-hidden',String(!open));this.front.inert=open;this.back.inert=!open;const label=open?this.button.dataset.return:this.button.dataset.reveal;this.button.querySelector('[data-label]').textContent=label;this.button.setAttribute('aria-label',label+': '+this.name);}disconnectedCallback(){this.abort?.abort();this.abort=null;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-header"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('k-announcements'))customElements.define('k-announcements',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();this.slides=[...this.querySelectorAll('[data-announcement-slide]')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion:reduce)').matches||document.body.dataset.motion==='false';if(this.slides.length<2)return;const options={signal:this.abort.signal};this.addEventListener('mouseenter',()=>clearInterval(this.timer),options);this.addEventListener('mouseleave',()=>this.start(),options);this.addEventListener('focusin',()=>clearInterval(this.timer),options);this.addEventListener('focusout',()=>this.start(),options);document.addEventListener('visibilitychange',()=>this.start(),options);this.start();}
 show(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.hidden=i!==this.index);}
 start(){clearInterval(this.timer);if(!this.paused&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.interval)*1000);}
 disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.abort=null;}
});
document.addEventListener('click',event=>{if(event.target.closest('[data-open-fit],[data-open-cart]'))document.querySelectorAll('.mobile-nav[open],.kmega[open],.knav-dropdown[open]').forEach(menu=>menu.open=false);document.querySelectorAll('.kmega[open],.knav-dropdown[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.kmega[open],.knav-dropdown[open],.mobile-nav[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});
document.addEventListener('focusin',event=>{document.querySelectorAll('.kmega[open],.knav-dropdown[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('cart:updated',event=>{const count=Number(event.detail?.cart?.item_count);if(!Number.isFinite(count))return;document.querySelectorAll('.kheader-count').forEach(el=>{el.textContent=count;el.hidden=count===0;});});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('k-hero-slideshow'))customElements.define('k-hero-slideshow',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.slides=[...this.querySelectorAll('[data-hero-slide]')];this.dots=[...this.querySelectorAll('[data-hero-go]')];this.index=0;this.paused=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;this.show(0);if(this.slides.length<2)return;this.querySelector('.hero-controls').hidden=false;this.addEventListener('click',e=>{const go=e.target.closest('[data-hero-go]');if(go){this.paused=true;this.show(Number(go.dataset.heroGo));}if(e.target.closest('[data-hero-pause]'))this.paused=!this.paused;this.schedule();},{signal});this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},{signal});this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},{signal});this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();});},{signal});document.addEventListener('visibilitychange',()=>this.schedule(),{signal});this.motion.addEventListener('change',e=>{if(e.matches){this.paused=true;}this.schedule();},{signal});document.addEventListener('shopify:block:select',e=>{const index=this.slides.findIndex(slide=>slide===e.target||slide.contains(e.target));if(index>=0){this.paused=true;this.show(index);this.schedule();}},{signal});this.schedule();}
 show(index){this.index=index;const copy=this.querySelector('.hero-copy');if(copy){const hide=this.slides[index]?.dataset.showText==='false';copy.dataset.slideHidden=String(hide);copy.inert=hide;if(hide)copy.setAttribute('aria-hidden','true');else copy.removeAttribute('aria-hidden');}this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===index);slide.setAttribute('aria-hidden',String(i!==index));});this.dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));}
 schedule(){const pause=this.querySelector('[data-hero-pause]');if(pause)pause.textContent=this.paused?pause.dataset.playLabel:pause.dataset.pauseLabel;clearTimeout(this.timer);if(this.slides.length>1&&!this.paused&&!this.hovered&&!this.focused&&!document.hidden)this.timer=setTimeout(()=>{this.show((this.index+1)%this.slides.length);this.schedule();},5000);}
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-newsletter-popup"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('k-signup-popup')) {
  customElements.define('k-signup-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.key = 'kiseau-signup-dismissed';
      this.editor = this.dataset.editor === 'true';
      this.shown = false;
      this.externalSeen = false;
      this.delayPassed = false;
      this.externalOpen = () => [...document.querySelectorAll('[role="dialog"][aria-modal="true"],.klaviyo-form [role="dialog"],.klaviyo-form[class*="kl-private-reset"]')].some(element => !this.contains(element) && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && (element.matches('[role="dialog"]') || element.closest('[role="dialog"]')));
      this.remember = () => { if (!this.editor) { try { localStorage.setItem(this.key, String(Date.now() + Number(this.dataset.days) * 86400000)); } catch (_) {} } };
      this.close = () => { this.remember(); if (this.dialog.open) this.dialog.close(); };
      this.open = manual => {
        if (this.dialog.open || (!manual && this.shown)) return;
        if (this.externalOpen() || document.querySelector('dialog[open]')) return;
        this.returnFocus = document.activeElement;
        this.dialog.showModal();
        this.shown = true;
        if (!this.editor) this.remember();
        this.querySelector('[data-kpopup-close]')?.focus({ preventScroll: true });
      };
      this.addEventListener('click', event => {
        if (event.target.closest('[data-kpopup-open]')) this.open(true);
        if (event.target.closest('[data-kpopup-close]')) this.close();
        if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close(); }
      }, options);
      this.dialog.addEventListener('cancel', () => this.remember(), options);
      this.dialog.addEventListener('close', () => { if (this.returnFocus?.isConnected && !this.externalOpen()) this.returnFocus.focus({ preventScroll: true }); }, options);
      this.checkExternal = () => {
        if (this.externalFrame) return;
        this.externalFrame = requestAnimationFrame(() => {
          this.externalFrame = null;
          if (this.isConnected && this.externalOpen()) { this.externalSeen = true; this.close(); }
        });
      };
      window.addEventListener('klaviyoForms', event => { if (event.detail?.type === 'open') this.checkExternal(); if (event.detail?.type === 'submit') this.remember(); }, options);
      this.observer = new MutationObserver(this.checkExternal);
      this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'aria-modal', 'style', 'class'] });
      this.checkExternal();
      if (this.editor) {
        document.addEventListener('shopify:section:select', event => { if (event.detail.sectionId === this.dataset.section) this.open(true); }, options);
        document.addEventListener('shopify:section:deselect', event => { if (event.detail.sectionId === this.dataset.section && this.dialog.open) this.dialog.close(); }, options);
      }
      if (this.querySelector('[data-kpopup-errors],[data-kpopup-success]')) { this.open(true); return; }
      if (this.editor || this.dataset.enabled !== 'true' || this.dataset.subscriber === 'true') return;
      try { if (Number(localStorage.getItem(this.key)) > Date.now()) return; } catch (_) {}
      this.check = () => {
        if (this.shown || this.externalSeen || !this.delayPassed || document.visibilityState !== 'visible') return;
        const available = document.documentElement.scrollHeight - window.innerHeight;
        if (available > 0 && window.scrollY / available * 100 < Number(this.dataset.scroll)) return;
        const active = document.activeElement;
        if (active?.matches('input,textarea,select,[contenteditable="true"]')) return;
        this.open(false);
      };
      window.addEventListener('scroll', this.check, { ...options, passive: true });
      document.addEventListener('visibilitychange', this.check, options);
      this.timer = window.setTimeout(() => { this.delayPassed = true; this.check(); }, Number(this.dataset.delay) * 1000);
    }
    disconnectedCallback() { clearTimeout(this.timer); cancelAnimationFrame(this.externalFrame); this.externalFrame = null; this.observer?.disconnect(); this.abort?.abort(); if (this.dialog?.open) this.dialog.close(); this.abort = null; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('k-product-gallery')) {
  customElements.define('k-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.stage = this.querySelector('.gallery-stage');
      if (!this.stage) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobile = matchMedia('(max-width: 749px)');
      this.slides = [...this.querySelectorAll('[data-media-id]')];
      this.thumbs = [...this.querySelectorAll('[data-gallery-target]')];
      this.header = document.querySelector('.k-header-section');
      this.scheduleSize = () => {
        if (this.sizeFrame) return;
        this.sizeFrame = requestAnimationFrame(() => {
          this.sizeFrame = 0;
          this.fitDesktop();
        });
      };
      this.stage.addEventListener('touchstart', event => {
        this.gesture = null;
        this.suppressClickUntil = 0;
        if (!this.mobile.matches || event.touches.length !== 1 || this.slides.length < 2) return;
        if (!event.target.closest('.zoom-trigger')) return;
        const touch = event.touches[0];
        this.gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, horizontal: false };
      }, { signal, passive: true });
      this.stage.addEventListener('touchmove', event => {
        const gesture = this.gesture;
        if (!gesture) return;
        if (event.touches.length !== 1) { this.gesture = null; return; }
        const touch = [...event.touches].find(item => item.identifier === gesture.id);
        if (!touch) return;
        const x = Math.abs(touch.clientX - gesture.x), y = Math.abs(touch.clientY - gesture.y);
        if (!gesture.horizontal && y > 10 && y > x) { this.gesture = null; return; }
        if (x > 10 && x > y * 1.2) gesture.horizontal = true;
        if (gesture.horizontal) {
          this.suppressClickUntil = performance.now() + 700;
          if (event.cancelable) event.preventDefault();
        }
      }, { signal, passive: false });
      this.stage.addEventListener('touchend', event => {
        const gesture = this.gesture;
        this.gesture = null;
        if (!gesture || event.touches.length) return;
        const touch = [...event.changedTouches].find(item => item.identifier === gesture.id);
        if (!touch) return;
        const dx = touch.clientX - gesture.x, dy = touch.clientY - gesture.y;
        const threshold = Math.max(30, Math.min(60, this.stage.clientWidth * .1));
        if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        this.suppressClickUntil = performance.now() + 700;
        const current = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        const rtl = getComputedStyle(this).direction === 'rtl';
        const direction = (dx < 0 ? 1 : -1) * (rtl ? -1 : 1);
        this.selectSlide((current + direction + this.slides.length) % this.slides.length);
      }, { signal, passive: true });
      this.stage.addEventListener('touchcancel', () => { this.gesture = null; }, { signal, passive: true });
      this.stage.addEventListener('click', event => {
        if (event.detail !== 0 && performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { signal, capture: true });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-target]');
        if (!thumb) return;
        const index = this.slides.findIndex(slide => slide.dataset.mediaId === thumb.dataset.galleryTarget);
        if (index >= 0) this.selectSlide(index);
      }, { signal });
      this.mediaObserver = new MutationObserver(() => this.syncThumbnails());
      this.mediaObserver.observe(this.stage, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.scheduleSize);
        this.resizeObserver.observe(this);
        if (this.header) this.resizeObserver.observe(this.header);
      }
      window.addEventListener('resize', this.scheduleSize, { signal, passive: true });
      window.addEventListener('scroll', this.scheduleSize, { signal, passive: true });
      window.visualViewport?.addEventListener('resize', this.scheduleSize, { signal, passive: true });
      this.mobile.addEventListener('change', this.scheduleSize, { signal });
      this.syncThumbnails();
      this.scheduleSize();
    }
    selectSlide(index) {
      if (!this.slides[index]) return;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      this.syncThumbnails();
    }
    syncThumbnails() {
      const current = this.slides.find(slide => !slide.hidden);
      this.thumbs.forEach(thumb => {
        if (thumb.dataset.galleryTarget === current?.dataset.mediaId) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }
    fitDesktop() {
      if (this.mobile.matches || this.closest('.quick')) {
        this.style.removeProperty('--gallery-height');
        this.style.removeProperty('--gallery-top');
        return;
      }
      const viewport = window.visualViewport?.height || window.innerHeight;
      const headerBottom = Math.max(0, this.header?.getBoundingClientRect().bottom || 0);
      const stickyTop = Math.ceil(headerBottom + 16);
      this.style.setProperty('--gallery-top', stickyTop + 'px');
      const top = Math.max(stickyTop, this.getBoundingClientRect().top);
      const height = Math.max(1, Math.floor(viewport - top - 16));
      this.style.setProperty('--gallery-height', height + 'px');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.mediaObserver?.disconnect();
      cancelAnimationFrame(this.sizeFrame);
      this.sizeFrame = 0;
      this.gesture = null;
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('k-looping-recommendations')) {
  customElements.define('k-looping-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.originals = Array.from(this.children).filter(card => card.classList.contains('card') && !card.hasAttribute('data-krec-clone'));
      if (!this.originals.length) return;
      this.window = this.closest('.krec__window');
      this.controls = Array.from(this.window.querySelectorAll('[data-krec-step]'));
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.logicalIndex = 0;
      this.dragging = false;
      this.touching = false;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mobileQuery.addEventListener('change', () => this.layout(true), { signal });
      this.addEventListener('scroll', () => {
        clearTimeout(this.settleTimer);
        if (this.looping && !this.jumping) this.settleTimer = setTimeout(() => this.normalize(), 150);
      }, { passive:true, signal });
      this.addEventListener('scrollend', () => this.normalize(), { signal });
      this.addEventListener('pointerdown', () => { this.dragging = true; }, { passive:true, signal });
      this.addEventListener('touchstart', () => { this.touching = true; }, { passive:true, signal });
      const release = () => {
        this.dragging = false;
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.normalize(), 150);
      };
      window.addEventListener('pointerup', release, { passive:true, signal });
      window.addEventListener('pointercancel', release, { passive:true, signal });
      const touchRelease = () => { this.touching = false; release(); };
      window.addEventListener('touchend', touchRelease, { passive:true, signal });
      window.addEventListener('touchcancel', touchRelease, { passive:true, signal });
      this.addEventListener('keydown', event => {
        if (!this.looping || event.target !== this || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.advance(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.controls.forEach(control => control.addEventListener('click', () => this.advance(Number(control.dataset.krecStep)), { signal }));
      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this.window);
      this.imageObserver = new ResizeObserver(() => this.measureImage());
      const image = this.originals[0].querySelector('.card-media');
      if (image) this.imageObserver.observe(image);
      this.layout();
    }
    layout(force = false) {
      const width = this.window.clientWidth;
      if (!width || (!force && Math.abs(width - (this.lastWidth || 0)) < 1)) return;
      if (this.looping && this.step) this.logicalIndex = this.mod(Math.round(this.scrollLeft / this.step) - this.originals.length);
      this.lastWidth = width;
      const mobile = this.mobileQuery.matches;
      this.looping = mobile && this.originals.length > 1;
      this.querySelectorAll('[data-krec-clone]').forEach(card => card.remove());
      this.controls.forEach(control => { control.hidden = !this.looping; });
      if (this.looping) {
        this.setAttribute('tabindex', '0');
        this.setAttribute('role', 'region');
        this.setAttribute('aria-roledescription', 'carousel');
      } else {
        this.removeAttribute('tabindex');
        this.removeAttribute('role');
        this.removeAttribute('aria-roledescription');
      }
      if (!mobile) {
        this.removeAttribute('data-loop-active');
        this.scrollLeft = 0;
        return;
      }
      const cardWidth = width * 0.74;
      this.step = cardWidth + 12;
      this.style.setProperty('--krec-card-width', `${cardWidth}px`);
      this.style.setProperty('--krec-side-padding', `${(width - cardWidth) / 2}px`);
      this.setAttribute('data-loop-active', '');
      if (this.looping) {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        this.originals.forEach(card => {
          before.append(this.clone(card));
          after.append(this.clone(card));
        });
        this.prepend(before);
        this.append(after);
      }
      this.jump((this.looping ? this.originals.length + this.logicalIndex : 0) * this.step);
      this.measureImage();
    }
    clone(card) {
      const clone = card.cloneNode(true);
      clone.setAttribute('data-krec-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      return clone;
    }
    mod(index) { return ((index % this.originals.length) + this.originals.length) % this.originals.length; }
    measureImage() {
      const image = this.originals[0]?.querySelector('.card-media');
      if (image) this.window.style.setProperty('--krec-image-height', `${image.getBoundingClientRect().height}px`);
    }
    jump(left) {
      cancelAnimationFrame(this.jumpFrame);
      this.jumping = true;
      this.classList.add('krec__jump');
      this.scrollLeft = left;
      this.jumpFrame = requestAnimationFrame(() => {
        this.classList.remove('krec__jump');
        this.jumping = false;
      });
    }
    normalize() {
      if (!this.looping || this.jumping || this.dragging || this.touching) return;
      const index = Math.round(this.scrollLeft / this.step);
      const count = this.originals.length;
      this.logicalIndex = this.mod(index - count);
      if (index < count || index >= count * 2) this.jump((count + this.logicalIndex) * this.step);
    }
    advance(direction) {
      if (!this.looping) return;
      this.normalize();
      const target = Math.round(this.scrollLeft / this.step) + direction;
      this.scrollTo({ left:target * this.step, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resizeObserver?.disconnect();
      this.imageObserver?.disconnect();
      clearTimeout(this.settleTimer);
      cancelAnimationFrame(this.jumpFrame);
      this.querySelectorAll('[data-krec-clone]').forEach(card => card.remove());
      this.lastWidth = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-reservation-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('k-campaign-slides')) {
 customElements.define('k-campaign-slides', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.slides = [...this.querySelectorAll('[data-campaign-slide]')];
   this.dots = [...this.querySelectorAll('[data-campaign-go]')];
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
   this.index = 0;
   this.show(0);
   if (this.slides.length < 2) return;
   this.querySelector('[data-campaign-controls]').hidden = false;
   this.addEventListener('click', event => {
    const dot = event.target.closest('[data-campaign-go]');
    if (dot) { this.paused = true; this.show(Number(dot.dataset.campaignGo)); }
    if (event.target.closest('[data-campaign-pause]')) this.paused = !this.paused;
    this.schedule();
   }, { signal });
   this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
   this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
   this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
   this.addEventListener('focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }); }, { signal });
   document.addEventListener('visibilitychange', () => this.schedule(), { signal });
   this.motion.addEventListener('change', event => { if (event.matches) this.paused = true; this.schedule(); }, { signal });
   this.schedule();
  }
  show(index) {
   this.index = index;
   const copy = this.querySelector('.kcampaign__copy');
   if (copy) {
    const hide = this.slides[index]?.dataset.showText === 'false';
    copy.dataset.slideHidden = String(hide);
    copy.inert = hide;
    if (hide) copy.setAttribute('aria-hidden', 'true');
    else copy.removeAttribute('aria-hidden');
   }
   this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
   this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
  }
  schedule() {
   clearTimeout(this.timer);
   const pause = this.querySelector('[data-campaign-pause]');
   if (pause) pause.textContent = this.paused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
   if (this.slides.length > 1 && !this.paused && !this.hovered && !this.focused && !document.hidden) {
    this.timer = setTimeout(() => { this.show((this.index + 1) % this.slides.length); this.schedule(); }, 5000);
   }
  }
  disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller = null; }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-review-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('k-review-marquee'))customElements.define('k-review-marquee',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener('click',()=>this.toggleAttribute('data-paused'));this.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();this.toggleAttribute('data-paused');}});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-signature-sets"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('k-signature-browser'))customElements.define('k-signature-browser',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
 const slides=[...this.querySelectorAll('[data-signature-slide]')];let slideIndex=0;
 const controls=this.querySelector('.ksignature__image-controls');
 const showSlide=index=>{if(!slides.length)return;slideIndex=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==slideIndex);const copy=this.querySelector('.ksignature__hero-copy');const hide=slides[slideIndex].dataset.imageNumber==='2'&&this.querySelector('.ksignature__hero').dataset.showSecondText==='false';copy.dataset.slideHidden=String(hide);copy.inert=hide;copy.setAttribute('aria-hidden',String(hide));const count=this.querySelector('[data-signature-count]');if(count)count.textContent=(slideIndex+1)+' / '+slides.length;};
 if(controls)controls.hidden=slides.length<2;
 this.addEventListener('click',event=>{const button=event.target.closest('[data-signature-direction]');if(button)showSlide(slideIndex+Number(button.dataset.signatureDirection));},{signal});showSlide(0);
this.select=(group,change=false)=>{const groups=[...this.querySelectorAll('[data-set-panel]')].map(p=>p.dataset.setPanel);const hasAll=!!this.querySelector('[data-set-group=all]');if(!groups.includes(group)&&!(group==='all'&&hasAll))group=hasAll?'all':groups[0];this.querySelectorAll('[data-set-panel]').forEach(panel=>panel.hidden=group!=='all'&&panel.dataset.setPanel!==group);this.querySelectorAll('[data-set-group]').forEach(link=>{if(link.dataset.setGroup===group)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});if(change){const url=new URL(location.href);url.hash='sets-'+group;history.pushState({...history.state},'',url);}};this.addEventListener('click',event=>{const link=event.target.closest('[data-set-group]');if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();this.select(link.dataset.setGroup,true);},{signal});window.addEventListener('popstate',()=>this.select(location.hash.replace('#sets-','')),{signal});document.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-set-panel]');if(panel&&this.contains(panel))this.select(panel.dataset.setPanel);},{signal});this.select(location.hash.replace('#sets-',''));}
 disconnectedCallback(){this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k-style-explorer"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('k-style-explorer')){
 customElements.define('k-style-explorer',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;this.controller=new AbortController();const options={signal:this.controller.signal};
   this.tabs=[...this.querySelectorAll('[data-style-tab]')];this.panels=[...this.querySelectorAll('[data-panel]')];this.status=this.querySelector('[data-style-status]');this.setAttribute('data-ready','');this.selectStyle(0,false);
   this.addEventListener('click',event=>{const tab=event.target.closest('[data-style-tab]');if(tab&&this.contains(tab)){event.preventDefault();this.selectStyle(Number(tab.dataset.index),true);}const feature=event.target.closest('[data-feature]');if(feature&&this.contains(feature))this.selectFeature(feature);},options);
   this.addEventListener('keydown',event=>{const tab=event.target.closest('[data-style-tab]');if(!tab)return;let next=this.tabs.indexOf(tab);const rtl=getComputedStyle(this).direction==='rtl';if(event.key==='ArrowRight')next+=rtl?-1:1;else if(event.key==='ArrowLeft')next+=rtl?1:-1;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else if(event.key===' '){event.preventDefault();this.selectStyle(next,true);return;}else return;event.preventDefault();next=(next+this.tabs.length)%this.tabs.length;this.selectStyle(next,false);this.tabs[next].focus({preventScroll:true});this.tabs[next].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});},options);
   document.addEventListener('shopify:block:select',event=>{const index=this.tabs.findIndex(tab=>tab.dataset.blockId===String(event.detail.blockId));if(index>=0&&this.contains(event.target))this.selectStyle(index,false);},options);
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
  motion(){return !matchMedia('(prefers-reduced-motion: reduce)').matches&&document.body.dataset.motion!=='false';}
  selectStyle(index,follow){
   if(!this.panels[index])return;const changed=this.activeIndex!==index;this.activeIndex=index;
   this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});this.panels.forEach((panel,i)=>panel.hidden=i!==index);
   const panel=this.panels[index];if(changed){this.panels.forEach(p=>this.resetFeatures(p));if(this.status)this.status.textContent=panel.dataset.styleName;if(this.motion())panel.animate([{opacity:.35,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'ease-out'});}
   if(changed&&follow&&matchMedia('(max-width:749px)').matches&&panel.getBoundingClientRect().top<100)panel.scrollIntoView({block:'start',behavior:this.motion()?'smooth':'instant'});
  }
  resetFeatures(panel){
   panel.removeAttribute('data-focused');
   panel.querySelectorAll('.kse__dot').forEach(dot=>{dot.setAttribute('aria-pressed','false');dot.setAttribute('aria-expanded','false');});
   panel.querySelectorAll('[data-feature-card]').forEach(card=>card.hidden=true);
   panel.querySelector('.kse__features').hidden=true;
   panel.querySelector('.kse__image-note').hidden=false;
  }
  selectFeature(feature){
   const panel=feature.closest('[data-panel]'),number=feature.dataset.feature;
   const card=panel.querySelector('[data-feature-card="'+number+'"]');if(!card)return;
   const active=feature.getAttribute('aria-pressed')!=='true';this.resetFeatures(panel);
   if(!active){if(this.status)this.status.textContent=panel.dataset.styleName;return;}
   feature.setAttribute('aria-pressed','true');feature.setAttribute('aria-expanded','true');
   panel.setAttribute('data-focused','');card.hidden=false;
   panel.querySelector('.kse__features').hidden=false;panel.querySelector('.kse__image-note').hidden=true;
   if(this.status)this.status.textContent=panel.dataset.styleName+' · '+card.textContent.trim();
   if(matchMedia('(max-width:749px)').matches){
    requestAnimationFrame(()=>{if(card.hidden||panel.hidden)return;const rect=card.getBoundingClientRect();if(rect.bottom>window.innerHeight-16||rect.top<100)card.scrollIntoView({block:'nearest',behavior:this.motion()?'smooth':'instant'});});
   }
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
